import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-53831fba")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["r-grid alert", {
    'error': _ctx.item.type === 'error',
    'success': _ctx.item.type === 'success',
    'warning': _ctx.item.type === 'warning',
  }]
  }, [
    _createTextVNode(_toDisplayString(_ctx.item.value) + " ", 1),
    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
  ], 2))
})